<template>
<div class="page-content">
  <nav class="page-breadcrumb" id="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ breadcrumbA }}</li>
      <li class="breadcrumb-item active" aria-current="page">
        {{ breadcrumbB }}
      </li>
    </ol>
  </nav>

  <div class="row">
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title">Ajustes cargados por Regionales pendientes de auditoría</h6>
          <p class="card-description">
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-warning">En espera</span>
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-success">Aprobado</span>
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-danger">Rechazado</span>
          </p>
          <hr />
        </div>
      </div>
    </div>
  </div>

  <lista-carga v-if="load"></lista-carga>

  <div class="row" v-else>
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3">
            <div class="col">
              <label class="mr-sm-2">Desde</label>
              <input type="date" class="form-control mb-2 mr-sm-2" id="desde" />
            </div>
            <div class="col">
              <label class="mr-sm-2">Hasta</label>
              <input type="date" class="form-control mb-2 mr-sm-2" id="hasta" />
            </div>
            <div class="col">
              <label class="mr-sm-2 w-100">&nbsp;</label>
              <button class="btn btn-md btn-success w-100" id="buscar">Consultar Ajustes</button>
            </div>
          </div>

          <div class="table-responsive">
            <table
              id="ajustes_auditoria"
              class="table table-theme table-row v-middle"
              data-plugin="dataTable"
            >
              <colgroup>
                <col style="width: 90px" />
                <col style="width: 95px" />
                <col style="width: 145px" />
                <col style="width: 150px" />
                <col style="width: 115px" />
                <col style="width: 150px" />
                <col style="width: 85px" />
                <col style="width: 190px" />
                <col style="width: 150px" />
                <col style="width: 90px" />
                <col style="width: 170px" />
                <col style="width: 135px" />
                <col style="width: 145px" />
              </colgroup>
              <thead>
                <tr>
                  <th><span class="text-muted">Estado</span></th>
                  <th><span class="text-muted">ID ajuste</span></th>
                  <th><span class="text-muted">Fecha carga</span></th>
                  <th><span class="text-muted">Regional</span></th>
                  <th><span class="text-muted">DNI Regional</span></th>
                  <th><span class="text-muted">Operación</span></th>
                  <th><span class="text-muted">Legajo</span></th>
                  <th><span class="text-muted">Empleado</span></th>
                  <th><span class="text-muted">Concepto</span></th>
                  <th><span class="text-muted">Cantidad</span></th>
                  <th><span class="text-muted">Detalle</span></th>
                  <th><span class="text-muted">Auditado por</span></th>
                  <th><span class="text-muted">Acción</span></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="caso in ajustes" :key="caso.fireId">
                  <!-- 1 Estado -->
                  <td class="text-sm text-wrap">
                    <span class="badge text-uppercase" :class="badgeStatus(caso.status)">
                      {{ caso.status }}
                    </span>
                  </td>

                  <!-- 2 ID ajuste -->
                  <td class="text-sm text-wrap">{{ caso.fireIdCorto }}</td>

                  <!-- 3 Fecha carga -->
                  <td class="text-sm text-wrap">{{ caso.fecha_carga }}</td>

                  <!-- 4 Regional -->
                  <td class="text-sm text-wrap">{{ caso.responsable }}</td>

                  <!-- 5 DNI Regional -->
                  <td class="text-sm text-wrap">{{ caso.responsable_dni }}</td>

                  <!-- 6 Operación -->
                  <td class="text-sm text-wrap">{{ caso.operacion_raiz }}</td>

                  <!-- 7 Legajo -->
                  <td class="text-sm text-wrap">{{ caso.legajo }}</td>

                  <!-- 8 Empleado -->
                  <td class="text-sm text-wrap">{{ caso.nombre }}</td>

                  <!-- 9 Concepto -->
                  <td class="text-sm text-wrap">{{ caso.novedad }}</td>

                  <!-- 10 Cantidad -->
                  <td class="text-sm text-wrap">{{ caso.cantidad }}</td>

                  <!-- 11 Detalle -->
                  <td class="text-sm text-wrap">
                   
                    <button class="btn btn-sm btn-info mt-1" @click="verDetalle(caso)">Ver detalle</button>
                  </td>

                  <!-- 12 Auditado por -->
                  <td class="text-sm text-wrap">
                    <span v-if="caso.auditor_nombre && caso.auditor_nombre !== '-'">
                      {{ caso.auditor_nombre }}<br />
                      <small>{{ caso.fecha_auditoria }}</small>
                    </span>
                    <span v-else>-</span>
                  </td>

                  <!-- 13 Acción -->
                  <td class="text-sm text-wrap">
                    <select
                      
                      class="custom-select mr-3 resolucionSelect"
                      :value="caso.status"
                      @change="cambiarStatus($event, caso)"
                    >
                      <option value="En espera">En espera</option>
                      <option value="Aprobado">Aprobado</option>
                      <option value="Rechazado">Rechazado</option>
                    </select>

                   
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";
require("datatables.net");
require("datatables.net-buttons/js/buttons.colVis.js")();
require("datatables.net-buttons/js/buttons.html5.js")();
require("datatables.net-buttons/js/buttons.flash.js")();
require("datatables.net-buttons/js/buttons.print.js")();
require("../../../public/assets/css/data-table-estilos-propios.css");

import firebase from "firebase/app";
import "firebase/database";

import ListaCarga from "../ListaCarga";
import moment from "moment";

const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
const userPermission = JSON.parse(sessionStorage.getItem("userPermisos") || "[]");

export default {
  name: "AjustesAuditoriaGenesis",
  components: { ListaCarga },
  data: () => ({
    breadcrumbA: "Inicio",
    breadcrumbB: "Auditoría de Ajustes",
    descripcion: "Listado de ajustes cargados por Regionales para aprobar o rechazar",
    ajustes: [],
    load: true,
    moduloPermiso: "AjustesHrbp",
  }),
  methods: {
    isEditor(modulo) {
      if (userPermission.find(record => record.ModulosAccess === modulo)) {
        return userPermission.find(record => record.ModulosAccess === modulo).Editor;
      }
      return false;
    },

    addZero(i) {
      return i < 10 ? "0" + i : i;
    },

    timestampActual() {
      const h = new Date();
      const hora = this.addZero(h.getHours());
      const minutos = ("0" + h.getMinutes()).substr(-2);
      const segundos = ("0" + h.getSeconds()).substr(-2);

      const today = new Date();
      const m = today.getMonth() + 1;
      const mes = m < 10 ? "0" + m : m;
      let dia = today.getDate();
      dia = dia < 10 ? "0" + dia : dia;

      return today.getFullYear() + "-" + mes + "-" + dia + " " + hora + ":" + minutos + ":" + segundos;
    },

    auditorNombre() {
      const nombre = `${userData.leg_nombre || ""} ${userData.leg_apellido || ""}`.trim();
      return nombre || userData.name || "Usuario Génesis";
    },

    badgeStatus(status) {
      if (status === "Aprobado") return "badge-success";
      if (status === "Rechazado") return "badge-danger";
      return "badge-warning";
    },

    estadoDesdeStatus(status) {
      if (status === "Aprobado") return "aprobado";
      if (status === "Rechazado") return "rechazado";
      return "pendiente_auditoria";
    },

    normalizarAjuste(key, item) {
      const fechaCarga = item.fecha_carga || item.fecha || "-";
      const status = item.status || "En espera";

      return {
        fireId: key,
        fireIdCorto: key.substring(0, 8),
        fecha: item.fecha || fechaCarga,
        fecha_carga: fechaCarga,
        responsable: item.responsable || "-",
        responsable_id: item.responsable_id || "-",
        responsable_dni: item.responsable_dni || "-",
        operacion_id: item.operacion_id || "-",
        operacion_raiz: item.operacion_raiz || "-",
        legajo: item.legajo || "-",
        nombre: item.nombre || "-",
        id_novedad: item.id_novedad || item.bejerman_id || "-",
        bejerman_id: item.bejerman_id || item.id_novedad || "-",
        novedad: item.novedad || item.concepto || "-",
        concepto: item.concepto || item.novedad || "-",
        cantidad: item.cantidad || "-",
        detalle: item.detalle || "-",
        status: status,
        estado: item.estado || this.estadoDesdeStatus(status),
        auditor_nombre: item.auditor_nombre || "-",
        auditor_dni: item.auditor_dni || "-",
        auditor_legajo: item.auditor_legajo || "-",
        fecha_auditoria: item.fecha_auditoria || "-",
        observacion_auditoria: item.observacion_auditoria || "-",
      };
    },

    destruirDataTable() {
      if ($.fn.DataTable && $.fn.DataTable.isDataTable("#ajustes_auditoria")) {
        $("#ajustes_auditoria").DataTable().clear().destroy();
      }
    },

    getAjustes() {
      this.load = true;
      this.ajustes = [];
      this.destruirDataTable();

      firebase.database().ref("ajustes_novedades").once("value")
        .then((snapshot) => {
          const data = [];

          snapshot.forEach((child) => {
            data.push(this.normalizarAjuste(child.key, child.val() || {}));
          });

          data.sort((a, b) => {
            const fa = a.fecha_carga || "";
            const fb = b.fecha_carga || "";
            return fb.localeCompare(fa);
          });

          this.ajustes = data;
          this.load = false;

          this.$nextTick(() => {
            this.initDataTable();
          });
        })
        .catch((error) => {
          console.error("Error al obtener ajustes:", error);
          this.load = false;
          Swal.fire(
            "Error",
            "Ocurrió un error al cargar los ajustes. Revise la conexión o Firebase.",
            "error"
          );
        });
    },

    initDataTable() {
      this.destruirDataTable();

      const table = $("#ajustes_auditoria").DataTable({
        language: {
          decimal: ",",
          thousands: ".",
          info: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
          infoFiltered: "(filtrado de un total de _MAX_ registros)",
          loadingRecords: "Cargando...",
          lengthMenu: "Mostrar _MENU_ registros",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior"
          },
          processing: "Procesando...",
          search: "Buscar:",
          searchPlaceholder: "Término de búsqueda",
          zeroRecords: "No se encontraron resultados",
          emptyTable: "Ningún dato disponible en esta tabla",
          aria: {
            sortAscending: ": Activar para ordenar la columna de manera ascendente",
            sortDescending: ": Activar para ordenar la columna de manera descendente"
          },
        },
        scrollX: false,
        autoWidth: false,
        search: { regex: true },
        dom: "Bfrtip",
        responsive: false,
        nowrap: false,
        order: [[2, "desc"]],
        columns: [
          { width: "90px" },
          { width: "95px" },
          { width: "145px" },
          { width: "150px" },
          { width: "115px" },
          { width: "150px" },
          { width: "85px" },
          { width: "190px" },
          { width: "150px" },
          { width: "90px" },
          { width: "170px", orderable: false },
          { width: "135px" },
          { width: "145px", orderable: false }
        ],
        columnDefs: [
          { targets: "_all", className: "ajuste-celda" }
        ],
        drawCallback: function() {
          if ($.fn.DataTable && $.fn.DataTable.isDataTable("#ajustes_auditoria")) {
            $("#ajustes_auditoria").DataTable().columns.adjust();
          }
        },
        buttons: [
          "copy",
          "excel",
          "csv",
          {
            text: "En espera",
            className: "btn btn-warning",
            action: function() {
              table.columns(0).search("En espera").draw();
            }
          },
          {
            text: "Aprobado",
            className: "btn btn-success",
            action: function() {
              table.columns(0).search("Aprobado").draw();
            }
          },
          {
            text: "Rechazado",
            className: "btn btn-danger",
            action: function() {
              table.columns(0).search("Rechazado").draw();
            }
          },
          {
            text: "Todos",
            className: "btn btn-secondary",
            action: function() {
              table.columns(0).search("").draw();
              table.columns(2).search("").draw();
            }
          }
        ]
      });

      const diasEntreFechas = (desde, hasta) => {
        const diaActual = moment(desde);
        const fechas = [];
        while (diaActual.isSameOrBefore(hasta)) {
          fechas.push(diaActual.format("YYYY-MM-DD"));
          diaActual.add(1, "days");
        }
        return fechas;
      };

      $("#buscar").off("click").on("click", function() {
        const desdeVal = $("#desde").val();
        const hastaVal = $("#hasta").val();

        if (!desdeVal || !hastaVal) {
          Swal.fire("Atención", "Seleccione fecha desde y fecha hasta.", "warning");
          return;
        }

        const desde = moment(desdeVal);
        const hasta = moment(hastaVal);

        if (!desde.isValid() || !hasta.isValid() || desde.isAfter(hasta)) {
          Swal.fire("Atención", "El rango de fechas no es válido.", "warning");
          return;
        }

        const results = diasEntreFechas(desde, hasta);
        const filtro = results.join("|");
        table.column(2).search(filtro, true, false).draw();
      });
    },

    cambiarStatus(event, caso) {
      const nuevoStatus = event.target.value;
      const statusAnterior = caso.status;

      if (!nuevoStatus || nuevoStatus === statusAnterior) return;

      if (nuevoStatus === "Aprobado") {
        Swal.fire({
          title: "¿Aprobar ajuste?",
          text: `Se aprobará el ajuste de ${caso.nombre} por ${caso.novedad}.`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, aprobar",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.isConfirmed) {
            this.actualizarAjuste(caso, nuevoStatus, "-");
          } else {
            event.target.value = statusAnterior;
          }
        });
        return;
      }

      if (nuevoStatus === "Rechazado") {
        Swal.fire({
          title: "Rechazar ajuste",
          text: `Indique el motivo del rechazo para ${caso.nombre}.`,
          input: "textarea",
          inputPlaceholder: "Motivo del rechazo",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Rechazar",
          cancelButtonText: "Cancelar",
          inputValidator: (value) => {
            if (!value || value.trim().length < 3) {
              return "Ingrese una observación para rechazar el ajuste.";
            }
            return null;
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.actualizarAjuste(caso, nuevoStatus, result.value.trim());
          } else {
            event.target.value = statusAnterior;
          }
        });
        return;
      }

      if (nuevoStatus === "En espera") {
        Swal.fire({
          title: "¿Volver a En espera?",
          text: "El ajuste quedará nuevamente pendiente de auditoría.",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#fbbc06",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Sí, volver",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.isConfirmed) {
            this.actualizarAjuste(caso, nuevoStatus, "-");
          } else {
            event.target.value = statusAnterior;
          }
        });
      }
    },

    actualizarAjuste(caso, nuevoStatus, observacion) {
      const timestamp = this.timestampActual();
      const auditor = this.auditorNombre();
      const estado = this.estadoDesdeStatus(nuevoStatus);

      Swal.fire({
        title: "Actualizando...",
        text: "Por favor espere mientras se actualiza el ajuste.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const updateData = {
        status: nuevoStatus,
        estado: estado,
        auditado: nuevoStatus === "En espera" ? 0 : 1,
        fecha_auditoria: nuevoStatus === "En espera" ? "-" : timestamp,
        auditor_nombre: nuevoStatus === "En espera" ? "-" : auditor,
        auditor_dni: nuevoStatus === "En espera" ? "-" : (userData.leg_numdoc || userData.dni || "-"),
        auditor_legajo: nuevoStatus === "En espera" ? "-" : (userData.leg_numero || userData.legajo || "-"),
        observacion_auditoria: observacion || "-",
        visible_capital_humano: false
      };

      const historialData = {
        fecha: timestamp,
        accion: "Auditoría de ajuste",
        status_anterior: caso.status,
        status_nuevo: nuevoStatus,
        estado: estado,
        observacion: observacion || "-",
        nombre: auditor,
        dni: userData.leg_numdoc || userData.dni || "-",
        legajo: userData.leg_numero || userData.legajo || "-"
      };

      const ref = firebase.database().ref("ajustes_novedades/" + caso.fireId);

      ref.update(updateData)
        .then(() => ref.child("historial").push(historialData))
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Estado actualizado",
            text: `El ajuste quedó ${nuevoStatus}.`,
            timer: 1800,
            showConfirmButton: false
          });
          this.getAjustes();
        })
        .catch((error) => {
          console.error("Error al actualizar ajuste:", error);
          Swal.fire(
            "Error",
            "No se pudo actualizar el ajuste. Revise la conexión e intente nuevamente.",
            "error"
          );
          this.getAjustes();
        });
    },

    escapeHtml(value) {
      return String(value || "-")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },

    resumenDetalle(detalle) {
      const value = String(detalle || "-").trim();
      if (!value || value === "-") return "-";
      return value.length > 45 ? value.substring(0, 45) + "..." : value;
    },

    verDetalle(caso) {
      Swal.fire({
        title: "Detalle del ajuste",
        width: 800,
        html: `
          <div style="text-align:left; font-size:14px;">
            <b>ID Firebase:</b> ${this.escapeHtml(caso.fireId)}<br>
            <b>Fecha carga:</b> ${this.escapeHtml(caso.fecha_carga)}<br>
            <b>Regional:</b> ${this.escapeHtml(caso.responsable)} (${this.escapeHtml(caso.responsable_dni)})<br>
            <b>Operación:</b> ${this.escapeHtml(caso.operacion_raiz)}<br>
            <hr>
            <b>Legajo:</b> ${this.escapeHtml(caso.legajo)}<br>
            <b>Empleado:</b> ${this.escapeHtml(caso.nombre)}<br>
            <b>Concepto:</b> ${this.escapeHtml(caso.novedad)}<br>
            <b>ID concepto / Bejerman:</b> ${this.escapeHtml(caso.bejerman_id)}<br>
            <b>Cantidad:</b> ${this.escapeHtml(caso.cantidad)}<br>
            <b>Detalle:</b><br>${this.escapeHtml(caso.detalle)}<br>
            <hr>
            <b>Status:</b> ${this.escapeHtml(caso.status)}<br>
            <b>Auditado por:</b> ${this.escapeHtml(caso.auditor_nombre)}<br>
            <b>Fecha auditoría:</b> ${this.escapeHtml(caso.fecha_auditoria)}<br>
            <b>Observación auditoría:</b><br>${this.escapeHtml(caso.observacion_auditoria)}
          </div>
        `,
        confirmButtonText: "Cerrar"
      });
    }
  },

  mounted() {
    this.getAjustes();
  }
};
</script>

<style type="text/css">
.imprimir {
  color: #212529 !important;
  background-color: #fbbc06 !important;
  border-color: #fbbc06 !important;
}

/*
  Corrección de alineación DataTables:
  - la referencia de Génesis trabaja sin scrollX;
  - con scrollX + table-responsive DataTables calcula un ancho para el header
    y otro para el body, y visualmente las celdas quedan corridas;
  - el colgroup + table-layout fixed obliga a que las 13 columnas del thead
    y las 13 celdas del tbody usen exactamente el mismo ancho.
*/
#ajustes_auditoria {
  width: 100% !important;
  table-layout: fixed !important;
}

#ajustes_auditoria th,
#ajustes_auditoria td {
  box-sizing: border-box;
  vertical-align: middle !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  padding: 8px 10px !important;
}

#ajustes_auditoria th span {
  display: block;
  line-height: 1.15;
}

#ajustes_auditoria .badge {
  white-space: nowrap;
}

#ajustes_auditoria .custom-select {
  min-width: 125px;
  max-width: 100%;
}

#ajustes_auditoria .btn {
  white-space: nowrap;
}

.table-responsive {
  overflow-x: auto;
}
</style>